import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
    height: 100%;
    position: absolute;
    top: 0;
    user-select: none;

    &:before {
        background: linear-gradient(90deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%);
        content: '';
        height: 100%;
        left: 0;
        pointer-events: none;
        position: absolute;
        top: 0;
        width: 100px;
    }
`

const Icon = styled.svg`
    cursor: pointer;
    left: 10px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
`

type Props = {
    className?: string
    onClick: () => void
}

const ZoomMakerDownloadCarouselArrow = ({ className, onClick }: Props) => (
    <Container className={className}>
        <Icon width="50" height="50" xmlns="http://www.w3.org/2000/svg" onClick={onClick}>
            <path
                d="M18 25l.813-.944L30.983 10 33 11.889 21.644 25 33 38.111 30.982 40 18.813 25.944z"
                fill="#FFF"
                fillRule="nonzero"
            />
        </Icon>
    </Container>
)

export default ZoomMakerDownloadCarouselArrow
